type Props = { className?: string };

// Phia pearl mark — replaces the older smiley face. The asset comes
// from the brand "logo phia / phia-pearl" package; the gradients are
// inlined here so the mark renders standalone without any external
// fetch. Keep ids prefixed so they don't collide if the SVG is ever
// duplicated on the same page.
export function PhiaMark({ className }: Props) {
  return (
    <svg
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <defs>
        <radialGradient id="phia-pearl-body" cx="38%" cy="32%" r="75%">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="22%" stopColor="#fde7f0" />
          <stop offset="48%" stopColor="#e6c8ff" />
          <stop offset="72%" stopColor="#9fbcff" />
          <stop offset="100%" stopColor="#2b2540" />
        </radialGradient>
        <radialGradient id="phia-pearl-rim" cx="50%" cy="50%" r="50%">
          <stop offset="80%" stopColor="rgba(255,255,255,0)" />
          <stop offset="96%" stopColor="rgba(255,200,235,0.6)" />
          <stop offset="100%" stopColor="rgba(40,30,60,0.6)" />
        </radialGradient>
        <radialGradient id="phia-pearl-spec" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.9)" />
          <stop offset="100%" stopColor="rgba(255,255,255,0)" />
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="42" fill="url(#phia-pearl-body)" />
      <circle cx="50" cy="50" r="42" fill="url(#phia-pearl-rim)" />
      <ellipse
        cx="38"
        cy="34"
        rx="14"
        ry="8"
        fill="url(#phia-pearl-spec)"
        transform="rotate(-25 38 34)"
      />
      <ellipse
        cx="62"
        cy="68"
        rx="6"
        ry="3"
        fill="rgba(255,255,255,0.55)"
        transform="rotate(15 62 68)"
      />
    </svg>
  );
}
